import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import React, { FunctionComponent, useMemo } from "react";

import { UNITS } from "@shared/types";

import IcIcon from "../IcIcon";

const OPERATORS: Array<{
  icon: string;
  name: string;
  value: UNITS;
}> = [
  {
    value: null,
    name: "None",
    icon: "fluent-emoji-high-contrast:triangular-ruler",
  },
  {
    value: "in",
    name: "Inch",
    icon: "fluent-emoji-high-contrast:triangular-ruler",
  },
  {
    value: "ft",
    name: "Feet",
    icon: "fluent-emoji-high-contrast:triangular-ruler",
  },
  {
    value: "yd",
    name: "Yards",
    icon: "fluent-emoji-high-contrast:triangular-ruler",
  },
  {
    value: "mi",
    name: "Miles",
    icon: "fluent-emoji-high-contrast:triangular-ruler",
  },
];

export const UnitMenu: FunctionComponent<{
  onChange: (unit?: UNITS) => void;
  unit: UNITS | "";
  disabled?: boolean;
}> = ({ unit, onChange, disabled }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!disabled) {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const selectedUnit = useMemo(() => {
    return OPERATORS.find((o) => o.value === unit);
  }, [unit]);
  const currentIcon = "fluent-emoji-high-contrast:triangular-ruler";
  const buttonLabel = selectedUnit?.value
    ? `${selectedUnit.name} (${selectedUnit.value})`
    : "No unit selected";
  return (
    <div>
      <Tooltip title={`Unit of measure: ${buttonLabel}. Click to change.`}>
        <span>
          <IconButton
            onClick={handleClick}
            disabled={disabled}
            size="small"
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: "4px",
              px: 1,
              py: 0.5,
              fontSize: "0.75rem",
              fontWeight: 500,
              minWidth: 44,
              color: selectedUnit?.value ? "#1a3a5c" : "#9e9e9e",
              backgroundColor: "#f8f9fa",
              "&:hover": {
                backgroundColor: "#e9ecef",
                borderColor: "#2196f3",
              },
            }}
          >
            {selectedUnit?.value ? selectedUnit.value : "Unit"}
          </IconButton>
        </span>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {OPERATORS.map((menu) => {
          const key = menu.value;
          return (
            <MenuItem
              key={key}
              onClick={() => {
                onChange(menu.value);
                handleClose();
              }}
            >
              <ListItemIcon>
                <IcIcon icon={menu.icon} />
              </ListItemIcon>
              <ListItemText
                primary={menu.name}
                secondary={menu.value ?? "none"}
              />
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};
